import { Colors } from '../../colors';
export const lightTheme = {
    backgroundColor: Colors.GS0,
    onBackgroundColor: Colors.GS1000,
};
